module.exports = __webpack_public_path__ + "media/huiyi.3fdcd98c.mp4";